import { Vue, Component, Prop, Inject, Watch } from 'vue-property-decorator';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { RenovationColor, RenovationColorList } from '@/views/components/styleConfig';
import { QinggerLibUtils } from '@/util';
import ShopDisplay from '@/views/components/shopDisplaySketchMap/display';
import LinkForm from '@/views/components/linkForm/linkForm.vue';
import Upload from '@/views/components/upload/upload.vue';
const isset = QinggerLibUtils.isset;

interface FlashAd {
  siteId?: string | number;
  showType?: number;
}
interface FlashAdList {
  fieldType?: string;
  ygswpId?: number;
  sort?: number;
  desc?: {
    pStyle?: number;
    customConfig: {
      propagatePic?: string;
      countDown?: number;
      isShowCountDown?: number;
      width?: number;
      height?: number;
      list?: FlashCustomList;
    };
  };
}
interface FlashCustomList {
  couponInfo?: { cplId?: string | number; couponCover?: string; points?: string | number };
  jumpPath?: {
    appName?: string;
    pagePath?: string;
  };
  officialAccount?: {
    accountTitle?: string;
    accountUrl?: string;
  };
  linkDesc?: string;
  LinkType?: number;
  linkId?: number;
}
@Component({
	mixins: [style],
  components: {
    ShopDisplay,
    LinkForm,
  },
})
export default class ShiningShow extends Vue {
  @Prop({ default: RenovationColor.redOrangeWhite })
    themeCode: number;

  @Prop()
    fromPage: number;

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Inject({ default: 0 })
    mode: number;

  // @ts-expect-error
  theme = RenovationColorList[this.themeCode];

  // data:FlashAdList={

  // }
  linkInfo: FlashCustomList = {};
  // 展示刘海屏
  showBangs = 0;
  // 是否开启闪屏广告
  selectOpt = 0;
  // // 图片宽
  imgWidth = 0;
  // 图片高
  imgHeight = 0;
  // 展示倒计时
  showTime = 0;

  ygswpId = 0;
  sgId = 0;
  siteId = 0;
  img = '';
  optionsTime = [{ value: 3 }, { value: 4 }, { value: 5 }, { value: 6 }];
  //   闪屏倒计时
  shiningTime = 3;
  classList = [];

  connectedClass = [];

  disabled = true;

  @Watch('img', { deep: true, immediate: true })
  watchImg(n, o) {
    if (n !== o) {
      this.img = n;
    }
  }

  async mounted() {
    this.connectedClass = await this.getAttributeList();
    this.classList = await this.getClassList();
    this.sgId = +this.$route.params.sgId || +this.$route.params.id;
    this.siteId = +this.$route.params.siteId;
    this.getData();
    console.log(this.mode);
  }

  getData(loading?) {
    IPSService.flashAdDetail({
      postParams: {
        siteId: this.siteId,
      },
    }).then(
      (res) => {
        const resp = res.list;
        const { ygswpId } = resp;
        const { propagatePic, countDown, isShowBangs, pStyle, isShowCountDown, list } = resp[0].desc;
        this.ygswpId = ygswpId;
        this.selectOpt = pStyle || 0;
        this.showBangs = isShowBangs || 0;
        this.img = propagatePic || '';
        this.shiningTime = countDown || 3;
        this.showTime = isShowCountDown || 0;
        if (list) {
          this.linkInfo = list[0].linkList[0];
        } else {
          this.linkInfo = {};
        }
        if (loading) {
          loading.close();
        }
      },
      () => {
        if (loading) {
          loading.close();
        }
      },
    );
  }

  public uploadSuccess(res: HttpAPIRetItem<any>) {
    this.getImgInfo(res).then((img: any) => {
      this.img = res.content;
      this.imgWidth = img.width;
      this.imgHeight = img.height;
    });
  }

  getImgInfo(info) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = info.content;
      const arr = { width: 0, height: 0 };
      img.onload = function() {
        arr.width = img.width;
        arr.height = img.height;
        resolve(arr);
      };
    });
  }

  // 关联分类
  public getAttributeList(): Promise<any> {
    return IPSService.getAttributeList().then((res) => {
      return isset(res, 'list') ? res.list : [];
    });
  }

  // 获取网点分类配置
  getClassList() {
    return IPSService.siteClassList({
      postParams: {
        siteId: this.siteId,
      },
    }).then((response) => {
      return response.list || [];
    });
  }

  dealShowTime(val) {
    this.showTime = val;
  }

  onLinkChange(val) {
    this.linkInfo = val;
  }

  isOpen(val) {
    if (!val) {
      (this.img = ''), (this.showTime = 0), (this.linkInfo = {}), (this.shiningTime = 3), (this.imgHeight = 0), (this.imgWidth = 0);
    }
  }

  save() {
    const postParams = {
      siteId: +this.$route.params.siteId,
      showType: 8,
      list: [
        {
          fieldType: 'flashPropagate',
          sort: 1,
          desc: {
            pStyle: this.selectOpt,
            isShowBangs: this.showBangs,
            propagatePic: this.img,
            width: this.imgWidth,
            height: this.imgHeight,
            countDown: this.shiningTime,
            isShowCountDown: this.showTime,
            list: [
              {
                linkList: [this.linkInfo],
              },
            ],
          },
        },
      ],
    };
    if (this.ygswpId !== 0) {
      postParams['ygswpId'] = this.ygswpId;
    }
    if (this.selectOpt && !this.img) {
      this.$message.error('请上传图片');
      return;
    }
    let loading = null;
    if (postParams.siteId) {
      loading = this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(225,225,225,0.3)',
      });
    }
    IPSService.flashAdSave({ postParams }).then(
      (res) => {
        if (res && res.result) {
          this.$message.success('保存成功');
        } else {
          this.$message.error('保存失败');
        }
        if (loading) {
          this.getData(loading);
        }
      },
      () => {
        if (loading) {
          loading.close();
        }
        this.$message.error('保存出错，请稍后重试');
      },
    );
  }

  render(h) {
    return (
      <section class="nav-Menu">
        <p class="nav-title nav-banges wid-178">
          闪屏广告示意图
          <el-switch v-model={this.showBangs} active-value={1} inactive-value={0} active-text="刘海屏" />
        </p>
        <div class="nav-container">
          {this.showBangs ? <div class="bangs" /> : ''}
          {this.showTime === 1 && <div class="flash-time">{this.shiningTime}S</div>}
          <div class="left-class">
            <div class="left-phone1">
              <img class="shining-pic" src={this.img}></img>
            </div>
          </div>

          <div class="right-config">
            <div class="header">闪屏广告</div>
            <div class="body">
              <div class="bottom-nav-config">
                <p class="title">闪屏广告</p>
              </div>
              <div class="container r-mt-8">
                <el-checkbox v-model={this.selectOpt} onChange={val => this.isOpen(val)} false-label={0} true-label={1}>
                  开启闪屏广告
                </el-checkbox>
                {this.selectOpt === 0 ? (
                  ''
                ) : (
                  <div>
                    <Upload img={this.img} maxSize={1024} noDelete={false} on-imgUploadSuccess={this.uploadSuccess.bind(this)} />
                    <p class="tip line-height-20">注：图片将上下、左右居中显示，如需铺满手机屏幕，建议上传分辨率达到600*1300px，不超过1M的图片，支持png、jpg、gif格式；</p>
                    <p class="p-customize">
                      <span class="wid-40">闪屏倒计时</span>
                      <span class="shining-time">
                        <el-select class="wid-45" v-model={this.shiningTime} placeholder="3">
                          {this.optionsTime.map((v) => {
                            return <el-option label={v.value} value={v.value}></el-option>;
                          })}
                        </el-select>
                        &nbsp;秒
                        <el-checkbox class="r-mt-12" v-model={this.showTime} false-label={0} true-label={1} onChange={val => this.dealShowTime.bind(this, val)}>
                          在右上角展示倒计时
                        </el-checkbox>
                      </span>
                    </p>
                    <LinkForm
                      value={this.linkInfo}
                      empCode={this.$store.state.empCode}
                      onInput={val => (this.linkInfo = val)}
                      state={1}
                      sgId={+this.$route.params.sgId}
                      siteCodes={[this.$route.params.code]}
                      onChange={val => this.onLinkChange(val)}
                      goodsClassList={this.classList}
                      linkText="链接"
                      ref="linkForm"
                      class="hot-ad-link"
                      hotAd={false}
                      siteId={+this.$route.params.siteId}
                      attributeList={this.connectedClass}
                      exclude={[7, 8, 12, 14, 15, 16, 22]}
                      mode={this.mode}
                      sortShow={+this.mode === 2}
                      dialogFooter={+this.mode !== 2}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-save">
          <el-button type="primary" onClick={this.save.bind(this)}>
            保存
          </el-button>
        </div>
      </section>
    );
  }
}
